import _BaseAPIService from "../../_BaseAPIService";

const apiService = _BaseAPIService.instance;
const slug="api"
const OtpService = {
  create: async ({orgcode,data}) => {
    const response = await apiService.post(`/${slug}/menuorder?orgCode=${orgcode}`,data);
    return response.data;
  },
  registerGuestUser: async ({ email, orgcode, isEmail }) => {
    const response = await apiService.post(`/${slug}/auth/guestuser-register?cred=${email}&orgCode=${orgcode}&IsEmail=${isEmail}`);
    return response.data;
  },
};

export default OtpService;
